import { MinzeElement } from 'minze'

export class LvcTabPrevIcon extends MinzeElement {
  html = () => `
    <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect y="0.5" width="20" height="20" rx="10" fill="#1E007D"/>
<path d="M11.2002 6.9001C10.3047 7.84978 9.2767 8.8945 8.34685 10.0272C8.13667 10.2832 8.12209 10.6472 8.31253 10.9183C9.14517 12.1032 9.97408 12.9885 11.1162 14.1001" stroke="white" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
  `
}
